import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  termsSectionTitle: {
    id: 'MUKslK',
    defaultMessage: 'Terms & Conditions',
    description: 'Section title for terms and conditions',
  },
  termsCheckboxLabel: {
    id: 'CadHiM',
    defaultMessage: 'I agree to the WWEX Terms and Conditions',
    description: 'Checkbox label for accepting terms',
  },
  termsScrollRegionAriaLabel: {
    id: 'LpdJRN',
    defaultMessage: 'WWEX Terms and Conditions',
    description: 'Aria label for the scrollable terms and conditions text region',
  },
});
